import { RankedTester, and, isControl, optionIs, rankWith } from '@jsonforms/core';
export default rankWith(20, and(isControl, optionIs('EventContentPreview', true))) as RankedTester;
